import Typography from '@mui/material/Typography';

import type { ResolvableFieldSettings } from '../../ResolvableFields/types/resolvable-field-settings.type';

import { ConfidentialValue } from '../../ConfidentialValue';

import { ServiceCode } from './ServiceCode';
import { ResolvableServiceValueInfos } from './ResolvableServiceValueInfos';
import type { ServiceUsageCardCmp_ResolvableServiceBaseInterface } from './fragments/resolvable-service.fragment';

interface Props {
  readonly maskAmounts?: boolean;
  readonly resolvableFieldSettings: Partial<ResolvableFieldSettings>;
  readonly service: ServiceUsageCardCmp_ResolvableServiceBaseInterface;
}

export const ResolvableServiceInfos = ({
  maskAmounts = false,
  resolvableFieldSettings: pResolvableFieldSettings,
  service,
}: Readonly<Props>) => {
  const { label, title, value } = service;

  return (
    <>
      <Typography
        component="div"
        gutterBottom
        sx={{ lineHeight: 1.2 }}
        variant="h6"
      >
        {label}
      </Typography>
      <ServiceCode service={service} />
      <Typography gutterBottom sx={{ flexGrow: 1 }} variant="body2">
        {title}
      </Typography>
      {!maskAmounts && (
        <>
          <Typography color="text.secondary" variant="overline">
            Informations Service
          </Typography>
          {value ? (
            <ResolvableServiceValueInfos
              resolvableFieldSettings={pResolvableFieldSettings}
              value={value}
            />
          ) : (
            <ConfidentialValue />
          )}
        </>
      )}
    </>
  );
};
